module.exports = __webpack_public_path__ + "img/portrait-100.8b9eba94.jpg";